module.exports = __webpack_public_path__ + "static/media/logo.857f7166.png";